"use client";
import { RadioGroup as t, RadioGroupContext as e } from "@ark-ui/react";
import { radioGroup as n } from "@huspy/styled-system/recipes";
import { createStyleContext as r } from "../../utils/createStyleContext.mjs";
const { withProvider: i, withContext: o } = r(n), m = i(t.Root, "root"), c = o(
  t.Indicator,
  "indicator"
), d = o(
  t.ItemControl,
  "itemControl"
), I = o(
  t.Item,
  "item"
), a = o(
  t.ItemText,
  "itemText"
), p = o(
  t.Label,
  "label"
), C = {
  Context: e,
  Indicator: c,
  ItemControl: d,
  Item: I,
  ItemText: a,
  Label: p,
  Root: m,
  ItemHiddenInput: t.ItemHiddenInput
};
export {
  C as Radio
};
